var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"billing-history-amount"},[_vm._v(" "+_vm._s(_vm._f("dollar")(_vm.amount))+" "+_vm._s(_vm._f("uppercase")(_vm.currency))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }